export const DISCOVERY_OPTIONS = [
  {
    id: "none",
    label: "None",
    hint: "No extra discovery layer. The agent writes for the topic, voice, and platform.",
  },
  {
    id: "social_seo",
    label: "Social SEO",
    hint: "Uses natural platform search terms without keyword stuffing.",
  },
  {
    id: "ai_seo",
    label: "AI SEO",
    hint: "Frames clear answers, entities, source-backed claims, and useful context.",
  },
  {
    id: "social_ai",
    label: "Social + AI",
    hint: "Combines social search phrasing with answer-engine clarity.",
  },
];

export const HASHTAG_OPTIONS = [
  {
    id: "auto",
    label: "Auto",
    hint: "Platform-smart defaults: no tags for most channels, limited tags for Instagram.",
  },
  {
    id: "off",
    label: "Off",
    hint: "No hashtags in generated drafts.",
  },
  {
    id: "on",
    label: "On",
    hint: "Allow a capped, platform-specific set when relevant.",
  },
];

export function normalizeDiscoveryMode(value, legacySeo) {
  const raw = String(value || "").trim().toLowerCase().replace(/[-+]/g, "_");
  const aliases = {
    "": legacySeo === true ? "social_seo" : "none",
    off: "none",
    social: "social_seo",
    ai: "ai_seo",
    both: "social_ai",
    social_and_ai: "social_ai",
    social_ai_seo: "social_ai",
  };
  const mode = aliases[raw] || raw;
  return DISCOVERY_OPTIONS.some((option) => option.id === mode)
    ? mode
    : legacySeo === true ? "social_seo" : "none";
}

export function normalizeHashtagMode(value) {
  const mode = String(value || "auto").trim().toLowerCase();
  return HASHTAG_OPTIONS.some((option) => option.id === mode) ? mode : "auto";
}

export function normalizeRecipeDiscovery(recipe = {}) {
  return {
    ...recipe,
    discoveryMode: normalizeDiscoveryMode(recipe.discoveryMode || recipe.discovery_mode, recipe.seo),
    hashtagMode: normalizeHashtagMode(recipe.hashtagMode || recipe.hashtag_mode),
  };
}
